import Snowplow from 'constants/snowplow'
import { getCookies } from 'lib/web/cookieUtils'

type LabModalPopupAction = 'impression' | 'primary_cta_click' | 'secondary_cta_click' | 'dismiss'

interface LabModalPopupEventParams {
  popup: App.LabModalPopupResult
  action: LabModalPopupAction
  memberId?: string
  cta?: App.LabModalPopupCta
  ctaType?: 'primary' | 'secondary'
}

const snowplowSessionIdIndex = 6

function safelyDecodeCookieValue(value: string): string {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

function getSnowplowSessionId(): string | undefined {
  if (IS_SSR) {
    return undefined
  }

  const cookies = getCookies()
  const overrideSessionId = cookies[Snowplow.sessionIdCookie]

  if (overrideSessionId) {
    return overrideSessionId
  }

  const idCookie = Object.entries(cookies).find(([name]) => name.startsWith('_sp_id.'))?.[1]

  return idCookie ? safelyDecodeCookieValue(idCookie).split('.')[snowplowSessionIdIndex] : undefined
}

export async function labModalPopupEvent(params: LabModalPopupEventParams): Promise<void> {
  const { popup, action, memberId, cta, ctaType } = params
  const content = popup.content
  const modalId = popup.id
  const { trackClientEvent } = await import('analytics/analytics')

  trackClientEvent({
    subject: `lab_modal_popup_${modalId}`,
    action,
    category: 'lab_modal_popup',
    type: action === 'impression' ? 'nonInteraction' : 'interaction',
    context: [{
      schema: 'iglu:com.luxgroup/lab_modal_popup_context/jsonschema/1-0-0',
      data: {
        modal_id: modalId,
        popup_id: popup.popupId,
        popup_uuid: popup.id,
        popup_name: popup.name,
        priority: popup.priority,
        rank: popup.rank,
        display_frequency: popup.displayFrequency,
        style: popup.style ?? 'light',
        title: content.title,
        image_id: content.imageId,
        user_id: memberId,
        session_id: getSnowplowSessionId(),
        cta_type: ctaType,
        cta_label: cta?.label,
        cta_path: cta?.path,
      },
    }],
  })
}
